import { render, staticRenderFns } from "./TermsConsent.vue?vue&type=template&id=5815a68c&"
import script from "./TermsConsent.vue?vue&type=script&lang=js&"
export * from "./TermsConsent.vue?vue&type=script&lang=js&"
import style0 from "./TermsConsent.vue?vue&type=style&index=0&id=5815a68c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports